module.exports = __webpack_public_path__ + "static/media/gem1.c54e845d.png";